import styled from 'styled-components'
import { theme } from '../../../styles/theme'

interface IButon {
  hoverColor: string;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`

export const Button = styled.button<IButon>`
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.mainBg};
  border-radius: 20px;
  border: 1px solid ${theme.colors.secondLightGray};

  &:hover {
    background: ${({ hoverColor }) => hoverColor};
  }
`
